import { Base } from '@studiometa/js-toolkit';
import Deck from './Deck.js';

/**
 * @typedef {{
 *   $children: {
 *     Deck: Deck[]
 *   }
 * }} WishcardPageProps
 */

/**
 * WishcardPage component - displays sign data from the store.
 * @augments {Base<WishcardPageProps>}
 */
export default class WishcardPage extends Base {
  /**
   * Config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'WishcardPage',
    components: {
      Deck,
    },
  };

  /**
   * Mounted hook - populate page with sign data from localStorage.
   */
  async mounted() {
    const storedData = localStorage.getItem('signData');

    if (!storedData) {
      window.location.href = '/';
      return;
    }

    const signData = JSON.parse(storedData);

    const allCards = this.$children.Deck.flatMap((deck) => deck.$children.Card);

    allCards.forEach((cardComponent, index) => {
      const cardIndex = index + 1;
      const cardData = signData[`card_${cardIndex}`];
      if (!cardData) return;

      const cardEl = cardComponent.$el;

      const image = cardEl.querySelector('.card-image');
      if (image instanceof HTMLImageElement) {
        image.src = cardData.image;
        image.alt = cardData.name;
      }

      const nameEl = cardEl.querySelector('.card-name');
      if (nameEl) {
        nameEl.textContent = cardData.name;
      }
    });
  }
}
